import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Icon,
  Tooltip
} from "@chakra-ui/react";
import { FaUserShield } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { isAdminLoggedIn, logoutAdmin } from '../../services/adminAuth';

const AdminStatusIndicator = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = () => {
      setIsAdmin(isAdminLoggedIn());
    };
    
    checkAdminStatus();
    window.addEventListener('adminStatusChanged', checkAdminStatus);
    
    return () => {
      window.removeEventListener('adminStatusChanged', checkAdminStatus);
    };
  }, []);

  const handleLogout = () => {
    logoutAdmin("You are no longer in admin mode");
    // No toast here
  };

  if (!isAdmin) return null;

  return (
    <Box
      position="fixed"
      top="20px"
      right="20px"
      zIndex={9999}
    >
      <Tooltip label="You are logged in as Admin. Click to log out." placement="bottom" hasArrow>
        <Button
          colorScheme="red"
          leftIcon={<Icon as={FaUserShield} />}
          rightIcon={<Icon as={FiLogOut} />}
          onClick={handleLogout}
          size="md"
          boxShadow="lg"
          _hover={{ transform: 'scale(1.05)' }}
        >
          Admin Mode - Click to Logout
        </Button>
      </Tooltip>
    </Box>
  );
};

export default AdminStatusIndicator;